import { render, staticRenderFns } from "./side-by-side-row.vue?vue&type=template&id=7d4a8b63"
import script from "./side-by-side-row.vue?vue&type=script&lang=js"
export * from "./side-by-side-row.vue?vue&type=script&lang=js"
import style0 from "./side-by-side-row.vue?vue&type=style&index=0&id=7d4a8b63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports